module.exports = require('ember-lazy-list').ListView.extend({
    itemViewClass: null
});